import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ITab, ItemComponent, ModalComponent, TabsComponent, TagComponent } from '@tecalisdev/infinity';
import { IOcrOperation } from '../../../../../operations/models/operations.models';
import { WorkflowsHelperService } from '../../../../services/workflows-helper.service';

@Component({
	selector: 'app-modal-ocr-fraud-scoring-details',
	imports: [TranslatePipe, ModalComponent, TabsComponent, ItemComponent, TagComponent],
	templateUrl: './modal-ocr-fraud-scoring-details.component.html',
	styleUrl: './modal-ocr-fraud-scoring-details.component.scss',
})
export class ModalOcrFraudScoringDetailsComponent {
	@Input() antiFraudConfig?: IOcrOperation['config']['fraud_scoring'];
	@Output() closeEvent = new EventEmitter<void>();

	private workflowsHelper = inject(WorkflowsHelperService);

	public tabs: ITab[] = this.workflowsHelper.modalFraudScoringTabs;

	public closeModal(): void {
		this.closeEvent.emit();
	}
}
